export default __webpack_public_path__ + "static/media/laptop-using-lg-2.fecb6631.jpg";